/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApiCryptMessagePjToSend { 
    /**
     * Titre de la pièce jointe
     */
    filename: string;
    /**
     * Contenu de la pièce jointe en base64
     */
    data: string;
    /**
     * Chemin vers la pièce jointe originale
     */
    path?: string;
}

